import Vue from "vue";

// 引入所有需要注册的全局组件
import Button from "@/components/newComponents/Button/index.vue";
import Dialog from "@/components/newComponents/Dialog/index.vue";
import Tip from "@/components/newComponents/Tip/index.vue";
import Title from "@/components/newComponents/Title/index.vue";
import BackAction from "@/components/newComponents/BackAction/index.vue";
import Form from "@/components/newComponents/Form/index.vue";
import Table from "@/components/newComponents/Table/index.vue";
import Status from "@/components/newComponents/Status/index.vue";
import MenuTitle from "@/components/newComponents/MenuTitle/index.vue";
import ShopByPlatform from "@/components/newComponents/ShopByPlatform/index.vue";

//定义一个数组结构
const components = [
  { name: "yButton", component: Button },
  { name: "yDialog", component: Dialog },
  { name: "yTip", component: Tip },
  { name: "yTitle", component: Title },
  { name: "yBackAction", component: BackAction },
  { name: "yForm", component: Form },
  { name: "yTable", component: Table },
  { name: "yStatus", component: Status },
  { name: "yMenuTitle", component: MenuTitle },
  { name: "yShopByPlatform", component: ShopByPlatform },
];
//遍历数组进行循环注册
components.forEach((component) => {
  Vue.component(component.name, component.component);
});
